import pxToRem from "theme/base/pxToRem";
import colors from "theme/theme-light/colors";

const tabs = {
  styleOverrides: {
    root: {
      minHeight: pxToRem(42),
      ".MuiTabs-indicator": {
        backgroundColor: colors.background.bgBrand,
      },
    },
  },
};

export default tabs;
